// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"451":"9cd761fb","647":"42368f68","681":"cd1df864","830":"9cd761fb","894":"f4781fea"}[chunkId] + ".chunk.css";
};